// extracted by mini-css-extract-plugin
export default {"tab":"ConnectionPermissionLinksComponent_tab__zwWjf","copy":"ConnectionPermissionLinksComponent_copy__hBKp9"};